import React, { useContext, useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
} from "reactstrap";
import { Link } from "react-router-dom";
// import * as TBToolkit from "react-bootstrap-table2-toolkit";
// const ToolkitProvider = TBToolkit.default;
// const { Search } = TBToolkit;
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { useMutation, useQuery } from "@apollo/client";
import { GET_BOT_RESPONSES } from "./botresponses.query";
import AddInbox from "../../components/AddInbox/AddInbox";
import AddBotAutoamtion from "src/components/AddBotAutomation/AddBotAutomation";
import SweetAlert from "react-bootstrap-sweetalert";
import { DELETE_BOT } from "./deleteQuery";
import { ThemeContext } from "src/helpers/themeContext";
import DeleteModal from "src/components/deleteModal/deleteModal";
import "./BotResponses.scss";
import EditBotAutomation from "src/components/EditBotAutomation/EditBotAutomation";
import AddEstateAgentAutomation from "src/components/AddBotAutomation/AddEstateAgentAutomation";
import AddEstateAgentCTAAutomation from "src/components/AddBotAutomation/AddEstateAgentCTAAutomation";
import client from "../../apollo";
import { GET_ORGANISATIONS } from "src/components/AddBotAutomation/query";

const BotResponses = () => {
  const [tableData, setTableData] = useState<any>([]);
  const [searchText, setSearchText] = useState("");
  const [responseModal, setResponseModal] = useState(false);
  const [editResponseModal, setEditResponseModal] = useState(false);
  const [selectedResponse, setSelectedResponse] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [success_dlg, setsuccess_dlg] = useState(false);
  const [failure_dlg, setfailure_dlg] = useState(false);
  const [dynamic_description, setdynamic_description] = useState("");
  const Theme = useContext(ThemeContext);
  const [deleteBot] = useMutation(DELETE_BOT);
  const [bulkAddModal, setBulkAddModal] = useState(false);
  const [organisations, setOrganisations] = useState<any[]>([]);
  const [selectedOrg, setSelectedOrg] = useState<number>(-1);
  const [APIAccounts, setAPIAccounts] = useState<any[]>([]);
  const [selectedAPIAccount, setSelectedAPIAccount] = useState<number>(-1);
  const [selectedAutomationType, setSelectedAutomationType] = useState<string>("");
  const [bulkLoading, setBulkLoading] = useState(false);

  const columns = [
    {
      dataField: "Id",
      text: "Id",
      sort: true,
    },
    {
      dataField: "OrgName",
      text: "Org Name",
      sort: true,
    },
    {
      dataField: "APIAccountName",
      text: "API Name",
      sort: true,
    },
    {
      dataField: "Keyword",
      text: "Keyword",
      sort: true,
    },
    {
      dataField: "Order",
      text: "Order",
      sort: true,
    },
    {
      dataField: "IsEnabled",
      text: "IsEnabled",
      sort: true,
      formatter: (cell: boolean) => (cell ? "Yes" : "No"),
    },
    {
      dataField: "IsDeleted",
      text: "IsDeleted",
      sort: true,
      formatter: (cell: boolean) => (cell ? "Yes" : "No"),
    },
    {
      dataField: "AssignTo",
      text: "AssignTo",
      sort: true,
    },
    {
      dataField: "AssignToDepartment",
      text: "AssignToDepartment",
      sort: true,
    },
    {
      dataField: "menu",
      isDummyField: true,
      text: "Action",
      formatter: (cellContent: any, row: any) => (
        <React.Fragment>
          <UncontrolledDropdown style={{ justifySelf: "flex-start" }}>
            <DropdownToggle tag="button" className="btn btn-light btn-sm">
              <i className="uil uil-ellipsis-h"></i>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem onClick={() => onEdit(row)}>
                <i className="mdi mdi-pencil font-size-16 text-success me-1"></i>
                Edit
              </DropdownItem>
              <DropdownItem onClick={() => setDeleteModal(row)}>
                <i className="mdi mdi-delete font-size-16 me-1"></i>
                Delete Response
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </React.Fragment>
      ),
    },
  ];

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  const filteredData = tableData.filter((row: any) => {
    return Object.values(row).some((value: any) =>
      String(value).toLowerCase().includes(searchText.toLowerCase())
    );
  });

  const onEdit = (row: any) => {
    setSelectedResponse(row);
    setEditResponseModal(!editResponseModal);
  };

  const defaultSorted: any = [
    {
      dataField: "id",
      order: "asc",
    },
  ];

  // Removed row selection checkbox column

  const pageOptions = {
    sizePerPage: 10,
    totalSize: tableData.length,
    custom: true,
  };
  // const { SearchBar } = Search;

  const { data, refetch } = useQuery(GET_BOT_RESPONSES, {
    fetchPolicy: "no-cache",
  });

  const handleDelete = async (response: any) => {
    setDeleteModal(false);
    await deleteBot({
      variables: {
        id: response.Id,
        userId: localStorage.getItem("user_id"),
        time: new Date(Date.now()).toISOString(),
      },
    });
    setsuccess_dlg(true);
    setdynamic_description(
      "Item will not be available to the user now, it will be permanently deleted in 60 days"
    );
    refetch();
  };

  useEffect(() => {
    if (data && data.msgbox_BotResponse) {
      var tmpData = data.msgbox_BotResponse
        .filter((item: any) => item.Organisation)
        .map(function (item: {
          BotResponseId: number;
          EmailAddress: string;
          Keyword: string;
          IsEnabled: boolean;
          Organisation: { Name: string };
          APIAccount: { Name: string };
          Order: number;
          RequiresResponse: boolean;
          AssignTo: string;
          AssignToDepartment: string;
          IsDeleted: boolean;
        }) {
          return {
            Id: item.BotResponseId,
            APIAccountName: item?.APIAccount?.Name,
            OrgName: item?.Organisation?.Name,
            Keyword: item.Keyword,
            IsEnabled: item.IsEnabled,
            Order: item.Order,
            RequiresResponse: item.RequiresResponse,
            AssignTo: item.AssignTo,
            AssignToDepartment: item.AssignToDepartment,
            IsDeleted: item.IsDeleted,
          };
        });
      setTableData(tmpData);
    }
  }, [data]);

  const toggleAddResponseModal = () => {
    setResponseModal(!responseModal);
  };

  const handleUserClicks = () => {
    toggleAddResponseModal();
  };

  const refetchData = () => {
    refetch();
  };

  useEffect(() => {
    if (bulkAddModal) {
      loadOrgs();
    }
  }, [bulkAddModal]);

  useEffect(() => {
    if (selectedOrg !== -1) {
      const fullOrg: any = organisations.filter(
        (order: any) => order["OrganisationId"] == selectedOrg
      );
      if (fullOrg.length > 0) {
        setAPIAccounts(fullOrg[0].APIAccounts || []);
        if (fullOrg[0].APIAccounts && fullOrg[0].APIAccounts.length > 0) {
          setSelectedAPIAccount(fullOrg[0].APIAccounts[0]?.APIAccountId);
        }
      }
    }
  }, [selectedOrg, organisations]);

  const loadOrgs = async () => {
    const orgs = await client.query({
      query: GET_ORGANISATIONS,
    });
    const orgData = orgs?.data?.msgbox_Organisation || [];
    if (orgData.length > 0) {
      const orgId = orgData[0]["OrganisationId"];
      setOrganisations(orgData);
      setSelectedOrg(orgId);
      if (orgData[0].APIAccounts && orgData[0].APIAccounts.length > 0) {
        setSelectedAPIAccount(orgData[0].APIAccounts[0]?.APIAccountId);
      }
    }
  };

  const handleBulkAdd = async () => {
    if (!selectedOrg || selectedOrg === -1 || !selectedAPIAccount || selectedAPIAccount === -1 || !selectedAutomationType) {
      setdynamic_description("Please select Organisation, API Account, and Automation Type");
      setfailure_dlg(true);
      return;
    }

    const fullOrg: any = organisations.find(
      (org: any) => org["OrganisationId"] == selectedOrg
    );
    const fullAPI: any = APIAccounts.find(
      (api: any) => api["APIAccountId"] == selectedAPIAccount
    );

    if (!fullOrg || !fullAPI) {
      setdynamic_description("Invalid Organisation or API Account selected");
      setfailure_dlg(true);
      return;
    }

    setBulkLoading(true);
    try {
      let success = false;
      if (selectedAutomationType === "estateAgent") {
        success = await AddEstateAgentAutomation(fullOrg, fullAPI);
      } else if (selectedAutomationType === "estateAgentCTA") {
        success = await AddEstateAgentCTAAutomation(fullOrg, fullAPI);
      }

      if (success) {
        setdynamic_description("Bulk automation added successfully");
        setsuccess_dlg(true);
        setBulkAddModal(false);
        setSelectedAutomationType("");
        refetchData();
      } else {
        setdynamic_description("Failed to add bulk automation");
        setfailure_dlg(true);
      }
    } catch (error) {
      console.error("Error adding bulk automation:", error);
      setdynamic_description("An error occurred while adding bulk automation");
      setfailure_dlg(true);
    } finally {
      setBulkLoading(false);
    }
  };

  return (
    <React.Fragment>
      {success_dlg ? (
        <SweetAlert
          success
          title={Theme.name}
          onConfirm={() => {
            setsuccess_dlg(false);
          }}
        >
          {dynamic_description}
        </SweetAlert>
      ) : null}
      {failure_dlg ? (
        <SweetAlert
          error
          title={Theme.name}
          onConfirm={() => {
            setfailure_dlg(false);
          }}
        >
          {dynamic_description}
        </SweetAlert>
      ) : null}
      <DeleteModal
        isOpen={deleteModal !== false}
        cancel={() => setDeleteModal(false)}
        submit={() => handleDelete(deleteModal)}
      />
      <Card>
        <CardHeader>
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <h4 className="card-title">All Bot Responses</h4>
              </div>
            </Col>
            <Col md={6}>
              <div className="d-flex flex-wrap align-items-start justify-content-md-end mt-2 mt-md-0 gap-2 mb-3">
                <div>
                  <Link to="#" className="btn btn-light" onClick={refetchData}>
                    <i className="uil uil-refresh me-1"></i> Refresh
                  </Link>
                </div>
                <div>
                  <Link
                    to="#"
                    className="btn btn-light"
                    onClick={handleUserClicks}
                  >
                    <i className="uil uil-plus me-1"></i> Add New
                  </Link>
                </div>
                <div>
                  <Link
                    to="#"
                    className="btn btn-light"
                    onClick={() => setBulkAddModal(true)}
                  >
                    <i className="uil uil-layer-group me-1"></i> Bulk Add
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          <PaginationProvider pagination={paginationFactory(pageOptions)}>
            {({ paginationProps, paginationTableProps }) => (
              <React.Fragment>
                <Row className="mb-2">
                  <Col md="4">
                    <div className="search-box me-2 mb-2 d-inline-block">
                      <div className="position-relative">
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Search..."
                          value={searchText}
                          onChange={handleSearch}
                        />
                        <i className="bx bx-search-alt search-icon" />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xl="12">
                    <div className="table-responsive">
                      <BootstrapTable
                        bordered={false}
                        striped={false}
                        defaultSorted={defaultSorted}
                        classes="table align-middle table-nowrap"
                        headerWrapperClasses="thead-dark"
                        headerClasses="table-dark"
                        {...paginationTableProps}
                        keyField="Id"
                        columns={columns}
                        data={filteredData}
                      />
                    </div>
                  </Col>
                </Row>

                <Row className="align-items-md-center mt-30">
                  <Col className="inner-custom-pagination d-flex">
                    <div className="d-inline">
                      <SizePerPageDropdownStandalone {...paginationProps} />
                    </div>
                    <div className="text-md-right ms-auto">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>

      <AddBotAutoamtion
        modal={responseModal}
        setModal={setResponseModal}
        refresh={refetchData}
      />

      <EditBotAutomation
        modal={editResponseModal}
        setModal={setEditResponseModal}
        refresh={refetchData}
        selectedResponse={selectedResponse}
      />

      <Modal isOpen={bulkAddModal} toggle={() => setBulkAddModal(!bulkAddModal)} size="lg">
        <ModalHeader toggle={() => setBulkAddModal(false)} tag="h4">
          Bulk Add Bot Automation
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup className="mb-3">
                <Label>Select an Organisation</Label>
                <Input
                  type="select"
                  value={selectedOrg}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setSelectedOrg(Number(e.target.value));
                  }}
                >
                  <option value={-1}>Select Organisation</option>
                  {organisations.map((org: any) => (
                    <option key={org.OrganisationId} value={org.OrganisationId}>
                      {org.Name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <FormGroup className="mb-3">
                <Label>Select an API Account</Label>
                <Input
                  type="select"
                  value={selectedAPIAccount}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setSelectedAPIAccount(Number(e.target.value));
                  }}
                  disabled={selectedOrg === -1}
                >
                  <option value={-1}>Select API Account</option>
                  {APIAccounts.map((api: any) => (
                    <option key={api.APIAccountId} value={api.APIAccountId}>
                      {api.Name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <FormGroup className="mb-3">
                <Label>Select Automation Type</Label>
                <Input
                  type="select"
                  value={selectedAutomationType}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setSelectedAutomationType(e.target.value);
                  }}
                >
                  <option value="">Select Automation Type</option>
                  <option value="estateAgent">Estate Agent Automation</option>
                  <option value="estateAgentCTA">Estate Agent CTA Automation</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <div className="text-end">
                <button
                  type="button"
                  className="btn btn-light w-sm me-2"
                  onClick={() => {
                    setBulkAddModal(false);
                    setSelectedAutomationType("");
                  }}
                  disabled={bulkLoading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleBulkAdd}
                  disabled={bulkLoading || selectedOrg === -1 || selectedAPIAccount === -1 || !selectedAutomationType}
                >
                  {bulkLoading ? "Adding..." : "Add Bulk Automation"}
                </button>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default BotResponses;
